import styled from 'styled-components';

export const LoginFormStyled = styled.div`
  padding: 24px;
  .f_title {
    text-align: center;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
  }
  .input_wrap {
    &.mb_24 {
      margin-bottom: 24px;
    }
  }
`;
